import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const pt = {
  translation: {
    documentTitle: 'verifique.pt',
    appName: 'Verifique',
    landing: {
      title: 'verifique.pt',
      description:
        'O dns.pt exige agora a validação de contactos para novos registos de domínios .pt. Esta aplicação é usada para confirmar os dados de contacto associados ao pedido de registo.',
      referral:
        'Se chegou aqui através do seu registrar ou do dns.pt, este é o serviço usado para validar a informação de contacto antes de o registo do domínio poder ser concluído.',
      sections: [
        {
          title: 'O que esta aplicação faz',
          description: 'O verifique.pt é a aplicação de validação de contactos do dns.pt para registos de domínios .pt.',
        },
        {
          title: 'Porque a validação é necessária',
          description: 'A validação de contactos é agora obrigatória para novos registos de domínios .pt antes de o pedido avançar.',
        },
        {
          title: 'O que acontece a seguir',
          description: 'Quando receber um pedido de validação, esta aplicação confirma os dados de contacto ligados ao pedido de domínio.',
        },
      ],
    },
    verification: {
      title: 'Iniciar validação',
      description: 'Introduza o NIF/NIPC associado ao pedido de registo do domínio .pt para iniciar a validação.',
      vatLabel: 'NIF/NIPC',
      start: 'Iniciar validação',
      started: 'Validação iniciada. A sessão foi guardada neste dispositivo.',
      emailTitle: 'Validar email de contacto',
      emailDescription: 'Introduza o endereço de email do titular do(s) domínio(s) usado para efeitos de registo e renovação. Este número não será publicado no WHOIS/RDAP.',
      emailLabel: 'Email de contacto',
      requestEmailToken: 'Enviar código por email',
      resendEmailToken: 'Reenviar código',
      useOtherEmailAddress: 'Usar outro endereço de email',
      emailTokenRequested: 'O código foi enviado. Introduza-o abaixo para validar o email.',
      emailOtpLabel: 'Código recebido por email',
      validateEmailToken: 'Validar código',
      emailValidated: 'Email validado com sucesso.',
      emailRequestError: 'Não foi possível enviar o código por email.',
      emailValidateError: 'Não foi possível validar o código de email.',
      emailOtpInvalid: 'O código de email é inválido.',
      phoneTitle: 'Validar telefone de contacto',
      phoneDescription: 'Introduza, em formato internacional, o contacto telefónico do titular do(s) domínio(s) usado para efeitos de registo e renovação. Este número não será publicado no WHOIS/RDAP.',
      phoneLabel: 'Telefone de contacto',
      requestPhoneToken: 'Enviar código por SMS',
      resendPhoneToken: 'Reenviar código',
      useOtherPhoneNumber: 'Usar outro número',
      phoneTokenRequested: 'O código foi enviado. Introduza-o abaixo para validar o telefone.',
      phoneOtpLabel: 'Código recebido por SMS',
      validatePhoneToken: 'Validar código',
      phoneValidated: 'Telefone validado com sucesso.',
      phoneRequestError: 'Não foi possível enviar o código por SMS.',
      phoneValidateError: 'Não foi possível validar o código de telefone.',
      phoneOtpInvalid: 'O código de telefone é inválido.',
      reviewTitle: 'Confirmar e validar dados de conta',
      reviewLoading: 'A carregar dados de contacto...',
      reviewError: 'Não foi possível carregar os dados de contacto.',
      identityDataTitle: 'Dados de identificação',
      contactsTitle: 'Contactos',
      editIdentityData: 'Editar dados de identificação',
      editIdentityDataTitle: 'Editar dados de identificação do Titular',
      editIdentityDataDescription: 'Introduza de forma correta os dados que serão usados para efeitos de registo e renovação do(s) domínio(s). Todos os campos são de preenchimento obrigatório. Não conseguirá prosseguir sem submeter um documento oficial válido que comprove os dados introduzidos.',
      createIdentityDataTitle: 'Criar dados de identificação',
      createIdentityDataDescription: 'Não foi possível obter os dados de contacto oficiais. Preencha todos os campos para criar um novo contacto.',
      editIdentityDataWarning: 'Se alterar os dados obtidos das fontes oficiais, o processo deixará de ser automático. Para prosseguir, terá de submeter um documento oficial válido que comprove os dados (Nome, NIF e morada completa) que irá submeter.',
      noPreviousDataTitle: 'Não existem dados para o nif indicado',
      noPreviousDataDescription: 'Não é possível obter automaticamente os dados associados a este NIF. Para prosseguir, terá de preencher os dados de identificação e submeter um comprovativo de morada fiscal válido (Nome, NIF e morada completa).',
      manualValidationDelayWarning: 'A contra-validação manual poderá demorar alguns dias úteis e poderão ser solicitados meios de prova adicionais.',
      fullNameWarning: 'Por favor introduza o nome completo, não serão aceites processos onde conste apenas primeiro e último nome.',
      manualValidationProcessTitle: 'Processo de Validação Não Automático',
      confirmEditIdentityData: 'Editar dados',
      continue: 'Continuar',
      finish: 'Terminar processo de validação',
      confirmAccuracy: 'Declaro, para os devidos efeitos, que os dados introduzidos são exatos e verdadeiros, e que tenho legitimidade para efetuar esta ação, isentando a entidade remetente de qualquer responsabilidade decorrente de desconformidades ou falsas declarações.',
      authorizeProcessing: 'Tomo conhecimento e autorizo que os dados e comprovativos fornecidos sejam processados pela entidade remetente e seus subcontratados para cumprimento de obrigações legais (Diretiva NIS2 e Regulamento da DNS.PT), sendo conservados em arquivo seguro pelo período mínimo de 3 anos para os devidos efeitos.',
      close: 'Fechar',
      browse: 'Selecionar PDF',
      optional: 'Opcional',
      removeFile: 'Remover ficheiro',
      fiscalDocumentTitle: 'Documento Oficial Comprovativo dos Dados Acima',
      fiscalDocumentDescription: 'Anexe o PDF do documento oficial comprovativo.',
      fiscalDocumentInstructions: 'Submeta um documento oficial válido que comprove os dados introduzidos (Nome, NIF e morada completa).',
      fiscalDocumentExamplesLink: 'Exemplos de documentos aceites',
      fiscalDocumentIdentityWarning: 'Não envie cópias de documentos de identificação individuais (como o Cartão de Cidadão ou Passaporte), não serão aceites.\n\nOs dados fornecidos serão tratados exclusivamente para efeitos de registo e renovação de domínio(s), com total respeito pela sua confidencialidade e nos termos da legislação de proteção de dados aplicável.',
      fiscalDocumentExampleIndividuals: '• Pessoas Singulares: Comprovativo de residência fiscal retirado do Portal das Finanças.',
      fiscalDocumentExampleOrganizations: '• Empresas / Pessoas Coletivas: Cartão de Pessoa Coletiva Eletrónico, Certidão Permanente de empresa, Declaração de início ou alteração de atividade, ou Certidão de Enquadramento de IVA.',
      fiscalDocumentExampleAlternative: '• Alternativos: Outro documento oficial com a mesma validade jurídica e igual prova de autenticidade.',
      reviewImportantTitle: 'Importante',
      reviewImportantDescription: 'Este processo é apenas de validação de dados junto da entidade remetente. O registo ou renovação efetiva do(s) domínio(s) só ocorrerá após a conclusão do processo convencional com o respetivo pagamento e envio dos dados para o registry correspondente.',
      documentPdfOnly: 'Ficheiro PDF obrigatório.',
      validation: {
        required: 'Campo obrigatório.',
        invalidNif: 'NIF/NIPC inválido.',
        invalidZipcode: 'Código postal inválido. Use o formato 1234-567.',
        invalidCommercialRegistrationQueryCode: 'Código da certidão inválido. Use o formato 1234-5678-9012.',
      },
      saveContactDataError: 'Não foi possível guardar os dados de contacto.',
      completeError: 'Não foi possível terminar o processo de validação.',
      processStatus: {
        pending_validation: {
          title: 'Pedido submetido para análise',
          message:
            'Recebemos os seus dados e documentos. O seu pedido será agora analisado pela nossa equipa de validação.\n\nAté a análise estar concluída, o Contacto / NIC-HANDLE ainda não estará disponível para utilização em novos registos de domínios .PT.\n\nIremos notificá-lo por email assim que houver uma atualização.',
        },
        complete: {
          title: 'Validação concluída com sucesso',
          message:
            'O seu Contacto / NIC-HANDLE foi validado e está agora disponível para utilização em novos registos de domínios .PT.',
        },
      },
      fields: {
        vat: 'NIF/NIPC',
        name: 'Nome completo',
        org: 'Organização',
        commercialRegistrationQueryCode: 'Cód. da certidão de registo comercial',
        street: 'Morada',
        city: 'Cidade',
        zipcode: 'Código postal',
        country: 'País',
      },
      notAvailable: 'Não disponível',
      sources: {
        dnspt: 'dns.pt',
        vies: 'VIES',
        nifpt: 'nif.pt',
        manual: 'Manual',
      },
      startError: 'Não foi possível iniciar a validação.',
      apiNotConfigured: 'API_URL não configurado',
    },
    footer: {
      copyright: '© 2026 CLML. Todos os direitos reservados.',
      built: 'Construído em Portugal. De confiança em toda a Europa.',
      theme: {
        system: 'Sistema',
        light: 'Claro',
        dark: 'Escuro',
      },
    },
  },
}

const en = {
  translation: {
    documentTitle: 'verifique.pt',
    appName: 'Verifique',
    landing: {
      title: 'verifique.pt',
      description:
        'dns.pt now requires contact validation for new .pt domain registrations. This application is used to confirm the contact details associated with the registration request.',
      referral:
        'If you were sent here by your registrar or by dns.pt, this is the service used to validate the contact information before the domain registration can be completed.',
      sections: [
        {
          title: 'What this app does',
          description: 'verifique.pt is the dns.pt contact validation app used during .pt domain registration.',
        },
        {
          title: 'Why validation is required',
          description: 'Contact validation is now required for new .pt domain registrations before the request can move forward.',
        },
        {
          title: 'What happens next',
          description: 'When a registrant receives a validation request, this app is used to confirm the contact details linked to the domain order.',
        },
      ],
    },
    verification: {
      title: 'Start verification',
      description: 'Enter the VAT number associated with the .pt domain registration request to start validation.',
      vatLabel: 'VAT number',
      start: 'Start verification',
      started: 'Verification started. The session was saved on this device.',
      emailTitle: 'Validate contact email',
      emailDescription: 'Enter the domain holder email address used for registration and renewal purposes. This address will not be published in WHOIS/RDAP.',
      emailLabel: 'Contact email',
      requestEmailToken: 'Send email code',
      resendEmailToken: 'Resend code',
      useOtherEmailAddress: 'Use other email address',
      emailTokenRequested: 'The code was sent. Enter it below to validate the email.',
      emailOtpLabel: 'Code received by email',
      validateEmailToken: 'Validate code',
      emailValidated: 'Email validated successfully.',
      emailRequestError: 'Could not send the email code.',
      emailValidateError: 'Could not validate the email code.',
      emailOtpInvalid: 'The email code is invalid.',
      phoneTitle: 'Validate contact phone',
      phoneDescription: 'Enter, in international format, the domain holder phone contact used for registration and renewal purposes. This number will not be published in WHOIS/RDAP.',
      phoneLabel: 'Contact phone number',
      requestPhoneToken: 'Send SMS code',
      resendPhoneToken: 'Resend code',
      useOtherPhoneNumber: 'Use other phone number',
      phoneTokenRequested: 'The code was sent. Enter it below to validate the phone number.',
      phoneOtpLabel: 'Code received by SMS',
      validatePhoneToken: 'Validate code',
      phoneValidated: 'Phone number validated successfully.',
      phoneRequestError: 'Could not send the SMS code.',
      phoneValidateError: 'Could not validate the phone code.',
      phoneOtpInvalid: 'The phone code is invalid.',
      reviewTitle: 'Confirm and validate account data',
      reviewLoading: 'Loading contact data...',
      reviewError: 'Could not load contact data.',
      identityDataTitle: 'Identity data',
      contactsTitle: 'Contacts',
      editIdentityData: 'Edit identity data',
      editIdentityDataTitle: 'Edit the Holder Identification Data',
      editIdentityDataDescription: 'Enter correctly the data that will be used for the registration and renewal of the domain(s). All fields are mandatory. You will not be able to continue without submitting a valid official document proving the entered data.',
      createIdentityDataTitle: 'Create identity data',
      createIdentityDataDescription: 'Official contact data could not be found. Fill in all fields to create a new contact.',
      editIdentityDataWarning: 'If you change the data obtained from official sources, the process will no longer be automatic. To continue, you will need to submit a valid official document proving the data (Name, VAT number, and full address) that you will submit.',
      noPreviousDataTitle: 'There is no data for the indicated VAT number',
      noPreviousDataDescription: 'It is not possible to automatically obtain the data associated with this VAT number. To continue, you will need to fill in the identification data and submit a valid proof of tax address (Name, VAT number, and full address).',
      manualValidationDelayWarning: 'Manual re-validation may take a few business days and additional supporting evidence may be requested.',
      fullNameWarning: 'Please enter your full name. Processes that only include a first and last name will not be accepted.',
      manualValidationProcessTitle: 'Non-Automatic Validation Process',
      confirmEditIdentityData: 'Edit data',
      continue: 'Continue',
      finish: 'Finish verification process',
      confirmAccuracy: 'I declare, for all due purposes, that the data entered is accurate and true, and that I have the authority to perform this action, releasing the sending entity from any liability arising from discrepancies or false declarations.',
      authorizeProcessing: 'I acknowledge and authorize that the data and supporting documents provided may be processed by the sending entity and its subcontractors for compliance with legal obligations (NIS2 Directive and DNS.PT Regulation), and kept in a secure archive for a minimum period of 3 years for due purposes.',
      close: 'Close',
      browse: 'Choose PDF',
      optional: 'Optional',
      removeFile: 'Remove file',
      fiscalDocumentTitle: 'Official Document Proving the Data Above',
      fiscalDocumentDescription: 'Attach the PDF of the official supporting document.',
      fiscalDocumentInstructions: 'Submit a valid official document proving the entered data (Name, VAT number, and full address).',
      fiscalDocumentExamplesLink: 'Examples of accepted documents',
      fiscalDocumentIdentityWarning: 'Do not send copies of individual identification documents (such as a Citizen Card or Passport). The data provided will be processed exclusively for domain registration and renewal purposes, with full respect for its confidentiality and under the applicable data protection legislation.',
      fiscalDocumentExampleIndividuals: '• Individuals: Tax residence proof obtained from the Tax Authority Portal.',
      fiscalDocumentExampleOrganizations: '• Companies / Legal Entities: Electronic Legal Person Card, Permanent Company Certificate, Declaration of start or change of activity, or VAT Status Certificate.',
      fiscalDocumentExampleAlternative: '• Alternatives: Another official document with the same legal validity and equivalent proof of authenticity.',
      reviewImportantTitle: 'Important',
      reviewImportantDescription: 'This process is only for data validation with the sending entity. The actual registration or renewal of the domain(s) will only take place after completion of the conventional process, including payment and submission of the data to the corresponding registry.',
      documentPdfOnly: 'PDF file required.',
      validation: {
        required: 'Required field.',
        invalidNif: 'Invalid Portuguese VAT/NIF.',
        invalidZipcode: 'Invalid postal code. Use the format 1234-567.',
        invalidCommercialRegistrationQueryCode: 'Invalid commercial registration code. Use the format 1234-5678-9012.',
      },
      saveContactDataError: 'Could not save contact data.',
      completeError: 'Could not finish the verification process.',
      processStatus: {
        pending_validation: {
          title: 'Request submitted for review',
          message:
            'We have received your data and documents. Your request will now be reviewed by our validation team.\n\nUntil the review is complete, the Contact / NIC-HANDLE will not yet be available for use in new .PT domain registrations.\n\nWe will notify you by email as soon as there is an update.',
        },
        complete: {
          title: 'Validation completed successfully',
          message:
            'Your Contact / NIC-HANDLE has been validated and is now available for use in new .PT domain registrations.',
        },
      },
      fields: {
        vat: 'VAT number',
        name: 'Full name',
        org: 'Organisation',
        commercialRegistrationQueryCode: 'Commercial registration certificate query code',
        street: 'Street',
        city: 'City',
        zipcode: 'Zip code',
        country: 'Country',
      },
      notAvailable: 'Not available',
      sources: {
        dnspt: 'dns.pt',
        vies: 'VIES',
        nifpt: 'nif.pt',
        manual: 'Manual',
      },
      startError: 'Could not start verification.',
      apiNotConfigured: 'API_URL not configured',
    },
    footer: {
      copyright: '© 2026 CLML. All rights reserved.',
      built: 'Built in Portugal. Trusted across Europe.',
      theme: {
        system: 'System',
        light: 'Light',
        dark: 'Dark',
      },
    },
  },
}

i18n.use(initReactI18next).init({
  resources: { pt, en },
  lng: localStorage.getItem('verification-language') || 'pt',
  fallbackLng: 'pt',
  interpolation: { escapeValue: false },
})

export default i18n
